module.exports = __webpack_public_path__ + "img/youwin.5271b085.jpg";